class InfiniteScroll<TState> {
	private abortController: AbortController;
	/**
	 * when this element is scrolled into view, the loadMore function is called
	 */
	private becon: HTMLElement;
	/**
	 * the result of the loadMore function is appended to this element
	 */
	private content: HTMLElement;

	private currentActivity: Promise<void> = Promise.resolve();

	private isIntersecting = false;

	constructor(
		private container: HTMLElement,
		private state: TState,
		private loadMore: (state: TState, signal: AbortSignal, finished: () => void) => Promise<string | null>
	) {
		this.abortController = new AbortController();
		const content = this.container.querySelector<HTMLElement>('.infiniteScroll__content');
		const becon = this.container.querySelector<HTMLElement>('.infiniteScroll__becon');
		const loadingIndicator = this.container.querySelector<HTMLElement>('.infiniteScroll__loadingIndicator');

		if (!content || !becon) {
			throw new Error('infiniteScroll__content or infiniteScroll__becon not found');
		}
		this.content = content;
		this.becon = becon;

		this.abortController.signal.addEventListener('abort', () => {
			this.becon.remove();
			if (loadingIndicator) loadingIndicator.remove();
		});

		this.init();
	}

	private init() {
		const observer = new IntersectionObserver((entries) => {
			this.isIntersecting = entries.some((e) => e.isIntersecting);
			this.loadMoreContent();
		});

		observer.observe(this.becon);

		this.abortController.signal.addEventListener('abort', () => {
			observer.disconnect();
		});
	}

	private loadMoreContent() {
		if (this.isIntersecting) {
			this.currentActivity = this.currentActivity.then(() => {
				return this.loadMoreContentAsync();
			});
		}
	}

	public dispose() {
		this.abortController.abort();
	}

	private async loadMoreContentAsync() {
		const finishSignal = new AbortController();
		const finished = () => finishSignal.abort();
		const html = await this.loadMore(this.state, this.abortController.signal, finished);

		if (html !== null) {
			this.content.insertAdjacentHTML('beforeend', html);
			$('.fix-fouc-block').css('display', 'block');
		}

		if (html === null || finishSignal.signal.aborted) {
			this.dispose();
			return;
		}

		setTimeout(() => this.loadMoreContent(), 0);
	}
}

export class AjaxInfiniteScroll extends InfiniteScroll<{
	next: number;
	limit: number;
}> {
	constructor(container: HTMLElement, endpoint: string, next: number, limit: number) {
		super(container, { next, limit }, async (state, signal, finished) => {
			let binder = '?';
			if (endpoint.includes('?')) {
				binder = '&';
			}
			const resposne = await fetch(`${endpoint}${binder}from=${state.next}&limit=${state.limit}`, {
				signal,
				headers: { 'X-Requested-With': 'XMLHttpRequest' },
			});

			if (signal.aborted) return null;

			const html = await resposne.text();

			if (resposne.status !== 200) {
				console.warn(`failed to load infinite scroll: ${html}`);
				return null;
			}

			state.next += state.limit;

			if (html.trim() === '') {
				return null;
			}

			if (resposne.headers.get('X-End-Of-List') === 'true') {
				finished();
			}

			return html;
		});
	}
}
